import { routes, useParams } from '@redwoodjs/router'
import { Head, MetaTags } from '@redwoodjs/web'

import ItListCell from 'src/components/features/ItListDetails/ItListCell'
import UnlockItList from 'src/components/features/ItListDetails/UnlockItList/UnlockItList'
import MainLayout from 'src/layouts/MainLayout/MainLayout'
import { useSetBrandLogo } from 'src/lib/hooks/useSetBrandLogo'
import { getAbsoluteUrl } from 'src/lib/utils'

const ItListPage = () => {
  const { id: idString, activationCode, email } = useParams()
  const id = +idString
  useSetBrandLogo('loading')

  return (
    <>
      <MetaTags title="ItList" description="ItList page" />
      <Head>
        <link
          rel="canonical"
          href={getAbsoluteUrl(routes.itListCanonical({ id }))}
        />
      </Head>
      {activationCode && email ? (
        <MainLayout headerButtonVariant="secondaryGrayOutline">
          <UnlockItList id={id} activationCode={activationCode} email={email} />
        </MainLayout>
      ) : (
        <ItListCell id={id} />
      )}
    </>
  )
}

export default ItListPage
